import { Expose } from "class-transformer";
import { User } from "@core/model/user/user";

export class TicketLabor {
    @Expose() id: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() workerId: string | undefined;
    @Expose() hours: number | undefined;
    @Expose() hoursType?: string ;
    @Expose() billable: number | undefined;
    @Expose() estimated: number | undefined;
    @Expose() rate: number | undefined;
    @Expose() createdOn: Date | undefined;
    @Expose() createdById: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;
    @Expose() workerName: string | undefined;
    @Expose() workerPic: string | undefined;
    @Expose() ticketWorker: User | undefined;
    total?: number ;
    overtimeHours?: number ;
  }

  export class UpdateTicketLabor {
    @Expose() id: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() workerId: string | undefined;
    @Expose() hours: number | undefined;
    @Expose() hoursType?: string ;
    @Expose() billable: number | undefined;
    @Expose() estimated: number | undefined;
    @Expose() rate: number | undefined;
    @Expose() createdOn: Date | undefined;
    @Expose() createdById: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;
    @Expose() overtimeHours?: number ;

  }

  export class CreateTicketLabor  {
    @Expose() ticketId: string | undefined;
    @Expose() workerId: string | undefined;
    @Expose() hours: number | undefined;
    @Expose() hoursType?: string ;
    @Expose() billable: number | undefined;
    @Expose() estimated: number | undefined;
    @Expose() rate: number | undefined;
    @Expose() createdOn: Date | undefined;
    @Expose() createdById: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;
  }

  export class CreateLabor  {
    @Expose() ticketId: string | undefined;
    @Expose() workerId: string | undefined;
    @Expose() regularHours: number | undefined;
    @Expose() overtimeHours: number | undefined;
    @Expose() regularRate: number | undefined;
    @Expose() overtimeRate: number | undefined;
    @Expose() estimated: number | undefined;
    @Expose() createdById: string | undefined;
    
  }

  export class TicketLaborGrid {
    @Expose() id: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() workerId: string | undefined;
    @Expose() regularHours: number | undefined;
    @Expose() overTimeHours: number | undefined;
    @Expose() hoursType?: string ;
    @Expose() regularBillable: number | undefined;
    @Expose() overTimeBillable: number | undefined;
    @Expose() regularRate: number | undefined;
    @Expose() overTimeRate: number | undefined;
    @Expose() createdOn: Date | undefined;
    @Expose() createdById: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;
    @Expose() workerName: string | undefined;
    regularTotal?: number ;
    overTimeTotal?: number ;
  }

  export class TicketLaborGridUpdate {
    @Expose() ticketId: string | undefined;
    @Expose() workerId: string | undefined;
    @Expose() regularHours: number | undefined;
    @Expose() overTimeHours: number | undefined;
    @Expose() regularBillable: number | undefined;
    @Expose() overTimeBillable: number | undefined;
    @Expose() regularRate: number | undefined;
    @Expose() overTimeRate: number | undefined;
    @Expose() createdBy?: string ;
    
  }
